<template>
  <div>
    <div class="system-box">
      <!-- 超管 -->
      <div v-show="is_super_admin" style="width: 780px;height: 400px;">
        <!-- 标签 -->
        <div style="text-align:center;margin-bottom:20px;">
          <span :class="tab_type===0?'active':''" @click="tab_type=0" style="cursor: pointer;">创建账户</span>
        </div>
        <!-- 表单 -->
        <el-form :model="form" ref="form" label-width="120px" :rules="rules" style="min-height: 50px;">
          <!-- 分站管理员 5级地区 -->
          <el-form-item label="地区：">
            <el-select v-model="placeData[0]" clearable :disabled="dis[0]" @change="remoteMethod($event, 1)" placeholder="省" style="margin-right: 7.5px;">
              <el-option v-for="o in province" :key="o.id" :label="o.name" :value="o.id"></el-option>
            </el-select>
            <el-select v-model="placeData[1]" clearable :disabled="dis[1]" @change="remoteMethod($event, 2)" placeholder="市" style="margin-right: 7.5px;">
              <el-option v-for="o in city" :key="o.id" :label="o.name" :value="o.id"></el-option>
            </el-select>
            <el-select v-model="placeData[2]" clearable :disabled="dis[2]" @change="remoteMethod($event, 3)" placeholder="县">
              <el-option v-for="o in county" :key="o.id" :label="o.name" :value="o.id"></el-option>
            </el-select>
            <el-select v-model="placeData[3]" clearable :disabled="dis[3]" @change="remoteMethod($event, 4)" placeholder="镇" style="margin:10px 7.5px 0 0">
              <el-option v-for="o in town" :key="o.id" :label="o.name" :value="o.id"></el-option>
            </el-select>
            <el-select v-model="placeData[4]" clearable :disabled="dis[4]" @change="remoteMethod($event, 5)" placeholder="村" style="margin:10px 0 0 0;">
              <el-option v-for="o in village" :key="o.id" :label="o.name" :value="o.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="登录账号：" prop="name">
            <el-input type="text" v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="登录密码：" prop="newPass">
            <el-input type="password" autocomplete="new-password" v-model="form.newPass"></el-input>
          </el-form-item>
          <el-form-item label="确认密码：" prop="checkPass">
            <el-input type="password" autocomplete="new-password" v-model="form.checkPass"></el-input>
          </el-form-item>
          <el-form-item label="企业账号：" prop="organization">
            <el-switch v-model="form.organization"></el-switch>
          </el-form-item>
          <el-form-item label="企业名称：" prop="o_name" v-if="form.organization">
            <el-input type="text" v-model="form.o_name"></el-input>
          </el-form-item>
        </el-form>
        <!-- 按钮 -->
        <div style="text-align:center">
          <el-button type="primary" @click="submit()">创 建</el-button>
          <el-button style="margin-left:30px" @click="resetForm()">重 置</el-button>
          <el-button style="margin-left:30px" @click="downShow=true">下载模板</el-button>
          <el-button style="padding: 0"><file_Upload :_url="fileUrl"></file_Upload></el-button>
        </div>
      </div>
    </div>
    <!-- 模板下载对话框 -->
    <dowmloadplace :value="tab_type_value" :downShow="downShow" @cutOff="downShow=false"/>
  </div>
</template>

<script>
import { log } from 'util'
import mixin_area from '@/Mixins/mixin_area'
export default {
  mixins: [ mixin_area ],
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.form.checkPass !== '') {
          this.$refs.form.validateField('checkPass')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.form.newPass) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      fileUrl1: `${this.$api.imgUrl}/user/list/import`, // 管理员上传url
      fileUrl2: `${this.$api.imgUrl}/user/work/assign`, // 工作人员上传url
      form: { name: '', newPass: '', checkPass: ''},
      rules: {
        newPass: [{ validator: validatePass, message:"请输入密码", trigger: 'blur' }],
        name: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        checkPass: [{ validator: validatePass2, message:"两次输入的密码不相同", trigger: 'blur' }],
      },
      province: [],
      city: [],
      county: [],
      town: [],
      village: [],
      placeData: [],
      dis: [],

      downShow: false, // 模板下载对话框控制器
      tab_type: 0, // 0分站管理员 1一般管理员 2工作人员

      is_super_admin: true, // 超管
      is_province_admin: false, // 省级
      user_level: '', // 管理员级别 默认省级

      loadingInstance1: '',
    }
  },
  computed: {
    fileUrl() {
      return this.tab_type === 2 ? this.fileUrl2 : this.fileUrl1
    },
    tab_type_value() {
      return this.tab_type ===  2 ? '33' : '32'
    }
  },
  methods: {
    submit(){
      let place = []
      place = this.placeData.filter(x => x) // 过滤空字符串
      let arr = ['province','city','county','town','village']
      this.$refs.form.validate(valid => {
        if (valid) {
          if (place.length === 0) {
            return this.$message.info('请至少选择一个地区')
          } else {
            let rD = {}
            rD.name = this.form.name
            rD.password = this.form.newPass
            rD.o_name = this.form.o_name
            rD.personal = !this.form.organization
            rD.organization = this.form.organization
            rD.areaId = parseInt(place[place.length-1])
            console.log(rD)
            this.$api.createUserList(rD).then(res => {
              if (res.data.status == 0){
                this.$message.success("创建成功！")
              } else { this._status(res.data) }
            })
          }
        } else {
          return false
        }
      })
    },
    resetForm() {
      this.$refs.form.resetFields()
      this.placeData[0] = this.placeData[1] = this.placeData[2] = this.placeData[3] = this.placeData[4] = ''
    },
    // 获取位置
    areaGet(data) {
      this.$api.getPlace(data.value).then(res => {
        if (res.data.status === 0 ) {
          let response = JSON.parse(res.data.data)
          switch(data.key) {
            case 0 : this.province = response; break
            case 1 : this.city = response; break
            case 2 : this.county = response; break
            case 3 : this.town = response; break
            case 4 : this.village = response; break
          }
        } else{ this._status(res.data) }
      })
    },
    //设置默认地址
    getDefault() {
      if (this.userInfo.admin) {
        for (let i = 0; i < 5; i++) { this.dis.push(false) }
      } else {
        this.$api.getFather({areaId:this.userInfo.areaId}).then(res => {
          if (res.data.status === 0) {    
            let response = JSON.parse(res.data.data)
            response.forEach((o,i) => {
              this.areaGet({ value: { areaId: o.id }, key: i + 1 })
              // this.placeData.push({areaId:o.id})
              i === 5 ? this.dis.push(false) : this.dis.push(true)
              switch(o.level) {
                case 0 : this.placeData[0] = o.id; this.dis[0] = true; break
                case 1 : this.placeData[1] = o.id; this.dis[1] = true; break
                case 2 : this.placeData[2] = o.id; this.dis[2] = true; break
                case 3 : this.placeData[3] = o.id; this.dis[3] = true; break
                case 4 : this.placeData[4] = o.id; this.dis[4] = true; break
              }
            })
          } else { this._status(res.data) }
        })
      }
    },
    //筛选省市分站管理员下级已开通城市数据
    screen(key) {
      let areaId = this.userInfo.areaId
      this.$api.getScreen({ areaId }).then(res => {
        if (res.data.status == 0) {
          if (key == '1') {
            this.city = JSON.parse(res.data.data)
          } else if (key == '2') {
            this.county = JSON.parse(res.data.data)
          }
        } else { this._status(res.data) }
      })
    },
    //创建返回值封装
    handelRes(data) {
      if (data === 0) {
        this.$message.success('创建成功！')
      } else if (data === 10) {
        this.$message.error('权限不够!')
      } else if (data === 9) {
        this.$message.info('分站管理员已存在!')
      } else if (data === 8) {
        this.$message.info('名称已存在!')
      } else {
        this.$message.error('创建失败')
      }
    },
    //下载模板
    download() {
      let requst = {
        areaId: this.userInfo.areaId,
        templateType: this.tab_type === 2 ? '33' : '32'
      }
      this.$api.templateDown(requst).then(res => {
        if (res.data.status == 0 ) {
          this.$api.download_doc(res.data.data)
        } else{ this._status(res.data) }
      })
    },
  },
  created() {
    this.getDefault()
    this.areaGet({ value: { areaId: 0 }, key: 0 })
  },
}
</script>

<style scoped>
.system-box {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.system-box .active {
  color: #409EFF;
}
.system-box .upload-box {
  display: inline-block;
}
</style>